import "./northstar-future-vision.bb02b3aa.js";
import "./northstar-future-vision.cc6dd712.js";


      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea868"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea868"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $caV3w = parcelRequire("caV3w");

var $iERLf = parcelRequire("iERLf");

var $6uXpe = parcelRequire("6uXpe");

var $5jQtK = parcelRequire("5jQtK");

var $5FWqM = parcelRequire("5FWqM");
const $a1c0a72e98f9076f$var$FF_BODY = "'Telia Sans', system-ui, -apple-system, sans-serif";
const $a1c0a72e98f9076f$var$FF_MONO = "'JetBrains Mono', ui-monospace, 'SFMono-Regular', monospace";
const $a1c0a72e98f9076f$var$backStyle = {
    position: "fixed",
    top: 18,
    left: 24,
    fontFamily: $a1c0a72e98f9076f$var$FF_BODY,
    fontSize: 13,
    color: (0, $6uXpe.P).light,
    textDecoration: "none",
    letterSpacing: 1,
    opacity: 0.75,
    padding: "6px 13px",
    borderRadius: 999,
    border: "1px solid rgba(244,224,255,0.25)"
};
function $a1c0a72e98f9076f$var$Page() {
    return /*#__PURE__*/ (0, $caV3w.jsxs)("div", {
        style: {
            minHeight: "100vh",
            boxSizing: "border-box",
            color: (0, $6uXpe.P).white,
            fontFamily: $a1c0a72e98f9076f$var$FF_BODY,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            padding: "84px 28px 56px",
            position: "relative",
            background: "radial-gradient(circle at 70% 20%, rgba(0,212,255,0.10), transparent 55%), radial-gradient(circle at 20% 80%, rgba(153,10,227,0.18), transparent 55%), #29003E"
        },
        children: [
            /*#__PURE__*/ (0, $caV3w.jsx)("style", {
                children: `
        @import url('https://fonts.googleapis.com/css2?family=JetBrains+Mono:wght@400;700&display=swap');
        @keyframes fadeSlideUp { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }
      `
            }),
            /*#__PURE__*/ (0, $caV3w.jsx)("a", {
                href: "index.html",
                style: $a1c0a72e98f9076f$var$backStyle,
                children: (0, $5jQtK.COPY).ui.backLink
            }),
            /*#__PURE__*/ (0, $caV3w.jsxs)("div", {
                style: {
                    maxWidth: 1100,
                    width: "100%"
                },
                children: [
                    /*#__PURE__*/ (0, $caV3w.jsx)((0, $5FWqM.Kicker), {
                        color: (0, $6uXpe.P).gold,
                        children: (0, $5jQtK.COPY).sixg.kicker
                    }),
                    /*#__PURE__*/ (0, $caV3w.jsx)((0, $5FWqM.Heading), {
                        parts: (0, $5jQtK.COPY).sixg.headline,
                        size: "clamp(26px, 5vw, 50px)",
                        mb: 12
                    }),
                    /*#__PURE__*/ (0, $caV3w.jsx)((0, $5FWqM.Lede), {
                        size: 13,
                        mb: 28,
                        max: 800,
                        children: (0, $5jQtK.COPY).sixg.body
                    }),
                    /*#__PURE__*/ (0, $caV3w.jsx)((0, $5FWqM.SixGRoadmap), {
                        active: true
                    }),
                    /*#__PURE__*/ (0, $caV3w.jsxs)("div", {
                        style: {
                            marginTop: 24,
                            padding: "16px 24px",
                            background: `linear-gradient(135deg, ${(0, $6uXpe.P).gold}10, ${(0, $6uXpe.P).purple}10)`,
                            border: `1px solid ${(0, $6uXpe.P).gold}33`,
                            borderRadius: 12,
                            fontSize: 12,
                            color: "rgba(244,224,255,0.78)",
                            lineHeight: 1.65,
                            textAlign: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0, $caV3w.jsx)("strong", {
                                style: {
                                    color: (0, $6uXpe.P).gold,
                                    fontFamily: $a1c0a72e98f9076f$var$FF_MONO,
                                    fontSize: 11,
                                    letterSpacing: 1
                                },
                                children: (0, $5jQtK.COPY).sixg.note.label
                            }),
                            (0, $5jQtK.COPY).sixg.note.text
                        ]
                    })
                ]
            })
        ]
    });
}
const $a1c0a72e98f9076f$var$container = document.getElementById("root");
if ($a1c0a72e98f9076f$var$container) (0, $iERLf.createRoot)($a1c0a72e98f9076f$var$container).render(/*#__PURE__*/ (0, $caV3w.jsx)($a1c0a72e98f9076f$var$Page, {}));


//# sourceMappingURL=releases.1f0ea478.js.map
